<template>

<div>

	<com-title text="Checkout" />

	<com-item route="Convention.Checkout.Overview" text="Overview" />
	
	<com-item route="Convention.Checkout.Loans" text="Loans" :count="$convention.count.checkout.loans.total" count-tip="Total loans" :important="$convention.count.checkout.loans.overdue" important-tip="Overdue loans" />

	<com-item route="Convention.Checkout.Wins" text="Play to Win" :count="$convention.count.checkout.playtowin.total" count-tip="Total Play to Wins" />
	
	<com-item route="Convention.Checkout.Reports" text="Reports" :count="$convention.count.checkout.reports.total" count-tip="Total reports" :important="$convention.count.checkout.reports.pending" important-tip="Pending reports" />

	<com-title text="Usage" />

	<com-item route="Convention.Checkout.Attendees" text="By Attendee" />
	
	<com-item route="Convention.Checkout.Games" text="By Game" />

	<com-title text="Other" />
	
	<com-item route="Convention.Checkout.Settings" text="Settings" />

</div>

</template>

<script>

export default {

	components: {
		'com-title': () => import('./../../panel/common/Title'),
		'com-item': () => import('./../../panel/common/Item')
	}

}

</script>

<style scoped>

</style>
